





























import { Vue, Component } from "@/shared/vuepack";
import * as RouteNames from "@/employer/route-names";
import { GChart } from "vue-google-charts";
import { usePayrollDashboardStore } from "@/employer/store/payrollDashboard";

@Component({
  components: { GChart }
})
export default class PayrollContributions extends Vue {
  payrollDashboardStore = usePayrollDashboardStore();

  chartOptions = {
    colors: ["#8adac9", "#00af89"],
    legend: {
      position: "bottom"
    },
    hAxis: {
      gridlines: {
        color: "black"
      }
    },
    tooltip: {
      isHtml: true,
    },
    vAxis: {
      format: "currency",
      gridlines: {
        color: "black"
      },
      minValue: 0,
      maxValue: 1,
      viewWindowMode: "pretty"
    }
  };

  mounted () {
    this.payrollDashboardStore.initPayrollContributionsGraph();
  }

  clickBack () { this.payrollDashboardStore.payrollContributionsGraphBack(); }
  clickForward () { this.payrollDashboardStore.payrollContributionsGraphForward(); }

  get showNoDataMessage () {
    return this.payrollDashboardStore.isPayrollGraphDataEmpty;
  }
}
